import React from "react";
import { RIE_NumeroPolice_restriction } from "utils/regex";
import { MaskInputConform, MaskInputConformProps } from "./MaskInput";
import { iconNumeroPolice } from "utils/endAdornmentIcons";
import { useTranslation } from "react-i18next";

export function NumPoliceInput({ label, field, ...props }: MaskInputConformProps) {
  const { t } = useTranslation("common");

  return (
    <MaskInputConform
      label={label ?? t("contrat.infosContrat.numeroPolice")}
      mask={RIE_NumeroPolice_restriction}
      field={field}
      InputProps={iconNumeroPolice}
      {...props}
    />
  );
}
